module.exports = __webpack_public_path__ + "img/icon_mall_kr.7fbfb095.svg";